module.exports = __webpack_public_path__ + "static/media/wizard_4.0d4e4dd8.png";